import {takeLatest, put} from 'redux-saga/effects';
import {actions as listActions} from '../slices/CustomerSubsOrderListSlice';
import {actions} from '../slices/CustomerSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

// const getSearchCriteria = state => state.employeeList.searchCriteria;

function* getCustomerSubsOrderList ({payload: {page, limit, filters}}) {
    try {
        const response = 
        yield NetworkHandler.get(`${config.getUrl('bus_subscription_order')}/members/${filters.member_id}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}

// function* getEmployeeList({payload: {page, limit, filters}}) {
//     try {
//         const response = yield NetworkHandler.get(`${config.getUrl('employee_api')}`, {
//             params: {
//                 page: page ? page : null,
//                 size: limit,
//                 ...filters,
//             }
//         });
//         yield put({type: listActions.get_list_succeed.type, payload: {...response}});
//     } catch (error) {
//         NotificationHandler.notifyError(error.message);
//         yield put({type: listActions.get_list_failed.type, payload: error});
//     }
// }



// function* createEmployee({payload:{params}}) {
//     try {
//         const response = yield NetworkHandler.post(`${config.getUrl('employee_api')}`, {
//             ...params
//         });
//         yield put({type: actions.create_employee_succeed.type, payload: {...response}});
//         NotificationHandler.notifySuccess('Thêm thành công!');
//         const searchCriteria = yield select(getSearchCriteria);
//         yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
//         yield ModalHandler.closeAllModal();
//     } catch (error) {
//         NotificationHandler.notifyError(error.message);
//         yield put({type: actions.create_employee_failed.type, payload: error});
//     }
// }

function* updateCustomer({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_members')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.update_customer_succeed.type, payload: {...response.data}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.update_customer_failed.type, payload: error});
    }
}

// function* deleteEmployee({payload:{id}}) {
//     try {
//         const response = yield NetworkHandler.delete(`${config.getUrl('employee_api')}/${id}`);
//         yield put({type: actions.delete_employee_succeed.type, payload: {...response}});
//         NotificationHandler.notifySuccess('Xoá thành công!');
//         const searchCriteria = yield select(getSearchCriteria);
//         yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
//     } catch (error) {
//         NotificationHandler.notifyError(error.message);
//         yield put({type: actions.delete_employee_failed.type, payload: error});
//     }
// }

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getCustomerSubsOrderList);
    // yield takeLatest(actions.create_employee.type, createEmployee);
    yield takeLatest(actions.update_customer.type, updateCustomer);
    // yield takeLatest(actions.delete_employee.type, deleteEmployee);
}

export default watchRequestDetail;